import React, { useEffect, useState, useContext, useRef } from "react";
import GeographyIcon from "../../../../../../../assets/images/researcher_app/create/audience_geography_icon.svg";
import DemographicIcon from "../../../../../../../assets/images/researcher_app/create/audience_demographic_icon.png";
import CryptoUsageIcon from "../../../../../../../assets/images/researcher_app/create/audience_crypto_usage_icon.png";
import OnChainIcon from "../../../../../../../assets/images/researcher_app/create/audience_on_chain_icon.png";
import CloseIcon from "../../../../../../../assets/images/researcher_app/create/audience_sidebar_close_icon.png";
import TrashIcon from "../../../../../../../assets/images/researcher_app/create/sidebar_trash_icon.png";
import { NewPrimaryButton, PrimaryButton, SecondaryButton, PurpleSecondaryButton } from "../../common_components/Buttons";
import { NewDropdownQuestion, NewDropdownOption, NewIntegerField, FormField, NewDecimalField, DatePickerField } from "../../common_components/Forms";
import { useAlert } from "react-alert";
import Select from 'react-select';
import { WalletRequirementCard } from "./AudienceRequirements";
import IsValidEVMAddress from "../../../../../utility_components/IsValidAddress";






//  SideBar stuff - move to a new file

function AddRequirementsSideBar(props) {
    const onClickBackground = () => { e => e.stopPropagation() };
    // const backgroudnCssClass = props.backgroundColor == "dark" ? "sidebar-backdrop dark" : "sidebar-backdrop";

    return (
        <>
            {props.isOpen && (
                <div className={"sidebar-backdrop"} onClick={onClickBackground}>
                    {props.children}
                </div>
            )}
        </>
    );
}


// Primary content sidebar
function SideBarContent(props) {
    const [updatedRequirements, setUpdatedRequirements] = useState(props.activeRequirements);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const alert = useAlert();

    function updateRequirements(key, newValue) {
        const tempRequirements = {
            ...updatedRequirements, // Clone the existing requirements
            [key]: newValue // Update the specific key with the new value
        };
        // console.log("Updating to: ", tempRequirements);
        setUpdatedRequirements(tempRequirements); // Pass the updated object to the parent function
    }

    function removeRequirement(key) {
        const tempRequirements = {
            ...updatedRequirements, // Clone the existing requirements
        };
        delete tempRequirements[key];
        // console.log("Removing: ", tempRequirements);
        setUpdatedRequirements(tempRequirements); // Pass the updated
    }

    // Save the requirements and close the modal
    function saveRequirementsAndClose() {
        // Okay, so we want to save the requirements here. 
        // To do that, we need to caldulate what's changed
        // And then send appropriate API calls to update the requirements.

        // New Plan:
        // Send the whole thing to the API and let it deal with it. 
        setSaveInProgress(true);

        props.bulkSaveRequirements(props.category, updatedRequirements, (success, message) => {
            // This is the callback that gets called after the save is done
            if (success) {
                alert.success('Audience updated!');  // Update state or do other stuff
                setSaveInProgress(false);
                props.toggleModal();
            } else {
                alert.show(message, { type: 'error' })
                setSaveInProgress(false);
            }
        });
    }

    return (
        <div className="add-requirements-sidebar" onClick={e => e.stopPropagation()}>
            <div className="add-requirement-sidebar-content">
                <SideBarTitleRow icon={props.icon} title={props.availableRequirements["label"]} toggleModal={props.toggleModal} />
                <div className="sidebar-requirements-content-container">
                    {Object.keys(props.availableRequirements.options).map((key, index) => {
                        const values = props.availableRequirements.options[key];
                        const activeReq = updatedRequirements && updatedRequirements[key];
                        const selectedToggles = updatedRequirements && updatedRequirements[key];
                        return (<IndividualRequirementSection key={index} category={key} requirementOptions={values}
                            activeReq={activeReq} selectedToggles={selectedToggles}
                            updateRequirements={(newValue) => updateRequirements(key, newValue)}
                            removeRequirement={() => removeRequirement(key)} />)
                    })
                    }
                </div>
            </div>
            <div className="sidebar-button-row">
                <SecondaryButton text="Back" onClick={props.toggleModal} style={{ flexGrow: 1, height: "54px", borderRadius: "10px" }} />
                <NewPrimaryButton text="Save" submitting={saveInProgress} onClick={saveRequirementsAndClose} style={{ flexGrow: 1, height: "56px" }} />
            </div>
        </div>

    )
}


function WalletSideBarContent(props) {
    const [updatedRequirements, setUpdatedRequirements] = useState(props.activeRequirements);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const alert = useAlert();

    const [walletAddReqMode, setWalletAddReqMode] = useState(false);

    function removeRequirement(key) {
        const arrCopy = [...updatedRequirements];

        // Find the item with the matching id
        const itemToUpdate = arrCopy.find(item => item.id === key);

        // If the item is found, update its status
        if (itemToUpdate) {
            if (itemToUpdate.status === "temp") {
                // If it's a temp item, just remove it from the list
                arrCopy.splice(arrCopy.indexOf(itemToUpdate), 1);
            } else {
                itemToUpdate.status = "deleted";
            }

        }
        setUpdatedRequirements(arrCopy);
        // console.log("Removing: ", arrCopy);
    }

    // Save the requirements and close the modal
    function saveRequirementsAndClose() {
        // Okay, so we want to save the requirements here. 
        // To do that, we need to caldulate what's changed
        // And then send appropriate API calls to update the requirements.

        // New Plan:
        // Send the whole thing to the API and let it deal with it. 
        setSaveInProgress(true);

        props.bulkSaveRequirements(props.category, updatedRequirements, (success, message) => {
            // This is the callback that gets called after the save is done
            if (success) {
                alert.success('Audience updated!');  // Update state or do other stuff
                setSaveInProgress(false);
                props.toggleModal();
            } else {
                alert.show(message, { type: 'error' })
                setSaveInProgress(false);
            }
        });
    }

    return (
        <div className="add-requirements-sidebar" onClick={e => e.stopPropagation()}>
            {walletAddReqMode ?
                <>
                    {/* We're adding Requirements */}
                    <AddWalletRequirementSection {...props} setWalletAddReqMode={setWalletAddReqMode} walletRequirements={updatedRequirements} setUpdatedRequirements={setUpdatedRequirements} />
                </>
                :
                <>
                    {/* We're viewing and removing requirements */}
                    <div className="add-requirement-sidebar-content">
                        <SideBarTitleRow icon={props.icon} title={props.availableRequirements["label"]} toggleModal={props.toggleModal} />

                        <WalletOverviewRequirementsSection {...props} requirements={updatedRequirements} setWalletAddReqMode={setWalletAddReqMode} removeRequirement={removeRequirement} />
                    </div>
                    <div className="sidebar-button-row">
                        <SecondaryButton text="Back" onClick={props.toggleModal} style={{ flexGrow: 1, height: "54px", borderRadius: "10px" }} />
                        <NewPrimaryButton text="Save" submitting={saveInProgress} onClick={saveRequirementsAndClose} style={{ flexGrow: 1, height: "56px" }} />
                    </div>
                </>
            }
        </div>

    )
}


function WalletOverviewRequirementsSection(props) {

    function DeleteRequirementButton(props) {
        return (
            <div className="delete-requirement-button" onClick={props.onClick}>
                <img src={TrashIcon} height={14} width={14} />
                <div className="delete-requirement-text">Delete</div>
            </div>
        )
    }

    return (
        <div className="wallet-sidebar-existing-and-add-requirements-container">
            <div className="wallet-sidebar-add-requirements-prompt-container">
                <WalletSideBarTitle text="Add Requirements" />
                <div className="sidebar-button-row">
                    <PurpleSecondaryButton onClick={() => props.setWalletAddReqMode(true)} text="+ Create New Requirement" />
                    <div></div> {/* This keeps the button half wide */}

                </div>
            </div>
            <div className="wallet-sidebar-existing-requirements-container">
                <WalletSideBarTitle text="Existing Requirements" />

                {/* Map existing requirements to a row each */}
                {/* If none, put in placeholder text. */}
                <div className="existing-wallet-requirements-column-container">
                    {props.requirements && props.requirements.filter(item => item.status !== "deleted").length > 0 ?
                        props.requirements.map(requirement => {
                            if (requirement["status"] == "deleted") {
                                return null;
                            } else {
                                return (
                                    <div key={requirement["type"] + "-" + requirement["id"]} className="wallet-requirement-card-and-delete-container">
                                        <WalletRequirementCard key={requirement["type"] + "-" + requirement["id"]} requirement={requirement} />
                                        <DeleteRequirementButton onClick={() => props.removeRequirement(requirement["id"])} />
                                    </div>
                                )
                            }
                        })
                        :
                        <div className="existing-wallet-requirements-placeholder">No requirements added yet.</div>
                    }
                </div>
            </div>

        </div>
    )
}

function WalletSideBarTitle(props) {
    return (
        <div className="wallet-sidebar-title-row">
            <div className="wallet-sidebar-title-text">{props.text}</div>
        </div>
    )
}

function AddWalletRequirementSection(props) {
    const alert = useAlert();

    const [selectedOption, setSelectedOption] = useState(-1);

    const selectedRequirement = selectedOption != -1 && props.availableRequirements.options.find((option) => option.class_name == selectedOption);

    function setDropdownValue(value) {
        setSelectedOption(value);
    }

    // The current set of answers for this requirement
    const [answers, setAnswers] = useState({});

    function updateAnswers(key, value) {
        console.log("Updating answers: ", key, value);
        const tempAnswers = {
            ...answers,
            [key]: value
        };
        setAnswers(tempAnswers);
    }

    // OKay, this one adds the requirement to the full list of requirements.
    function addRequirement() {
        // First, check that all the fields are filled out.
        const requiredFields = selectedRequirement.fields.filter((field) => !field.optional) // All fields are required.
        const missingFields = requiredFields.filter((field) => !answers[field.name]);
        if (missingFields.length > 0) {
            alert.error("Please fill out all required fields.");
            return;
        }

        // If there is a field with contract_address, check that it's a valid address
        const contractAddressField = requiredFields.find((field) => field.name == "contract_address");
        if (contractAddressField && !(IsValidEVMAddress(answers["contract_address"]))) {
            alert.error("Please enter a valid contract address.");
            return;
        }

        // If there is a field with time_period_start, check that it's in the pst
        const timePeriodStartField = selectedRequirement.fields.find((field) => field.name == "time_period_start");
        if (timePeriodStartField && answers["time_period_start"] && new Date(answers["time_period_start"]) > new Date()) {
            alert.error("Please enter a start date in the past.");
            return;
        }


        // Create a new ID for the requirement.
        // It should be "temp_" + a random integer from 0-99
        var newId = "temp_" + Math.floor(Math.random() * 100);
        while (props.walletRequirements !== null && props.walletRequirements.find((req) => req.id == newId)) {
            newId = "temp_" + Math.floor(Math.random() * 100);
        }
        // Create the new requirement, adding in what we need.
        const newRequirement = {
            id: newId,
            type: selectedRequirement.class_name,
            status: "temp",
            human_name: selectedRequirement.label,
            ...answers,

        }

        // Add the new requirement to the list of requirements
        // IF props.walletRequirements is null, then we're adding the first requirement.
        // Otherwise, we're adding to the existing list.
        const newRequirements = props.walletRequirements ? [...props.walletRequirements, newRequirement] : [newRequirement];
        props.setUpdatedRequirements(newRequirements);
        // console.log("Adding requirement: ", newRequirement);
        // Close the add requirement section.
        props.setWalletAddReqMode(false);
    }


    return (
        <>
            <div className="add-requirement-sidebar-content">
                <SideBarTitleRow icon={props.icon} title={props.availableRequirements["label"]} toggleModal={props.toggleModal} />
                <div className="wallet-sidebar-add-requirements-container">
                    <div className="wallet-sidebar-add-requirements-top-subcontainer">
                        <WalletSideBarTitle text="Add Requirements" />
                        <NewDropdownQuestion value={selectedOption} onChange={(event) => setDropdownValue(event.target.value)} >
                            <NewDropdownOption isDisabled={true} value="-1"> Select type </NewDropdownOption>
                            {props.availableRequirements.options.map((option, index) => {
                                return (
                                    <NewDropdownOption value={option.class_name} key={option.class_name}>{option.label}</NewDropdownOption>
                                )
                            })
                            }
                        </NewDropdownQuestion>
                    </div>
                    {selectedOption != -1 && <WalletRequirementFields {...props} reqData={selectedRequirement} updateAnswers={updateAnswers} />}
                </div>
                <div className="sidebar-button-row">
                    <SecondaryButton text="Back" onClick={() => props.setWalletAddReqMode(false)} style={{ flexGrow: 1, height: "54px", borderRadius: "10px" }} />
                    <NewPrimaryButton text="Add" disabled={selectedOption == -1} onClick={() => addRequirement()} style={{ flexGrow: 1, height: "56px" }} />
                </div>
            </div>
        </>
    )
}

function WalletRequirementFields(props) {


    return (
        <div className="wallet-requirement-fields-container">
            <div className="wallet-requirement-thin-horizontal-gray-line" />
            <div className="wallet-requirement-fields-subcontainer ">
                {props.reqData && props.reqData.fields.map((field, index) => {
                    {/* const currentValue = props.answers[field.name]; */ }
                    return (
                        <WalletRequirementField key={index} field={field} onChange={(value) => props.updateAnswers(field.name, value)} />
                    )
                }
                )}
            </div>
        </div>
    )
}

function WalletRequirementField(props) {

    // GIven the value from a dropdown option, look up the label.
    const dropdownOptionLabel = (value) => {
        if (props.field.fieldType == "dropdown" && value != -1) {
            return props.field.dropdownOptions.find((option) => option.value == value).label;
        } else {
            return "";
        }
    }

    return (
        <div className="wallet-requirement-field-and-note-container">
            {props.field.fieldType == "decimal" &&

                <NewDecimalField key={props.field.name} placeholder={props.field.placeholder} label={props.field.label} onChange={(event) => props.onChange(event.target.value)} />
            }
            {props.field.fieldType == "number" &&
                <NewIntegerField key={props.field.name} placeholder={props.field.placeholder} label={props.field.label} onChange={(event) => props.onChange(event.target.value)} />
            }
            {props.field.fieldType == "dropdown" &&
                <NewDropdownQuestion placeholder="Select option" defaultValue={-1} onChange={(event) => props.onChange({ value: parseInt(event.target.value), label: dropdownOptionLabel(event.target.value) })} questionText={props.field.label} >
                    {props.field.dropdownOptions.map((option, index) => {
                        return (
                            <NewDropdownOption value={option.value} key={index}>{option.label}</NewDropdownOption>
                        )
                    })
                    }
                </NewDropdownQuestion>
            }
            {props.field.fieldType == "text" &&
                <FormField key={props.field.name} label={props.field.label} placeholder={props.field.placeholder} onChange={(event) => props.onChange(event.target.value)} />
            }
            {props.field.fieldType == "date" &&
                <DatePickerField key={props.field.name} label={props.field.label} placeholder={props.field.placeholder} onChange={(value) => props.onChange(value)} />
            }
            {props.field.footnote &&
                <div className="wallet-requirement-field-note">{props.field.footnote}</div>
            }
        </div>
    )
}



// --------------------------------
// Individual components
// --------------------------------


function SideBarTitleRow(props) {
    return (
        <div className="sidebar-title-row-container">
            <div className="sidebar-title-row">
                <img src={props.icon} height={44} width={44} />
                <div className="sidebar-title-text">{props.title}</div>
                <img src={CloseIcon} className="clickable-image" height={24} width={24} onClick={() => props.toggleModal()} />
            </div>
        </div>
    )
}



function IndividualRequirementSection(props) {
    const [showRequirements, setShowRequirements] = useState(props.activeReq);

    function tempSaveToggleRequirement(index, operation) {
        let newState = [...props.selectedToggles.selected];

        if (operation === "add") {
            newState.push(index);
        } else if (operation === "remove") {
            newState = newState.filter((value) => value !== index);
        }

        // console.log(newState);
        props.updateRequirements({ selected: newState });
    };


    function tempSaveRequirement(value) {
        // console.log("Saving requirement: ", value);
        props.updateRequirements(value)
    }

    function toggleRequirements() {
        if (!showRequirements) {
            // Turning it on. If it's a toggle, set the default to all toggles on.
            props.updateRequirements(getDefaultRequirement(props.requirementOptions.type, props.requirementOptions.options));
        } else {
            // Turning it off. Delete the requirement.
            props.removeRequirement();
        }
        setShowRequirements(!showRequirements);
    }

    function RedTrashIcon() {
        return (
            <img src={TrashIcon} height={14} width={14} />
        )
    }

    function ShowRequirementButton() {
        if (showRequirements) {
            return (
                <div className="hide-requirement-toggle-button" onClick={() => toggleRequirements()}>
                    <RedTrashIcon />
                    <div className="hide-requirement-toggle-text">Remove requirement</div>
                </div>
            )
        } else {
            return (
                <div className="show-requirement-toggle-button" onClick={() => toggleRequirements()}>
                    <div className="show-requirement-toggle-text">
                        Add requirement
                    </div>
                </div>
            )
        }
    }

    return (
        <div className="individual-requirement-section">
            <div className="individual-requirement-section-title-row-div">
                <div className="individual-requirement-section-title">{props.requirementOptions["label"]}</div>
                <ShowRequirementButton />
            </div>
            {/* Only show the toggles and stuff if the requirement is turned on */}
            {showRequirements && (

                <div className="requirement-toggles-and-description-div">
                    <div className="requirement-description">{props.requirementOptions["description"]} </div>
                    {props.requirementOptions.type == "toggles" ?
                        <div className="individual-requirement-section-toggles">
                            {/* // Iterate through each of the options. */}
                            {props.requirementOptions.options.map((option) => {
                                const index = option.id;
                                const active = props.selectedToggles && props.selectedToggles.selected.includes(index);
                                return (<IndividualRequirementValue value={option} id={index} key={index} active={active} onChange={(index, action) => tempSaveToggleRequirement(index, action)} />)
                            })}
                        </div>
                        :
                        props.requirementOptions.type == "boolean" ?
                            <BooleanToggle active={props.selectedToggles == null ? "true" : props.selectedToggles}
                                onChange={(value) => tempSaveRequirement(value)} />
                            :
                            props.requirementOptions.type == "country-select" ?
                                <CountryRequirement selectedCountryList={props.selectedToggles} availableCountries={props.requirementOptions.options} onChange={(value) => tempSaveRequirement(value)} />
                                :
                                props.requirementOptions.type == "age-range" ?
                                    <AgeRangeRequirement ageHash={props.selectedToggles} onChange={(value) => tempSaveRequirement(value)} />
                                    :
                                    <></>
                    }
                </div>
            )}

        </div>
    )
}

// Requirements that are a series of booleans (e.g. industry, education, and other demographics). 
// This is one of those rows.
function IndividualRequirementValue(props) {
    const active = props.active == null ? true : props.active;

    return (
        <div className="individual-toggle-row">
            <div className="individual-toggle-label">
                {props.value.label}
            </div>
            <ToggleSwitch active={active} toggleActive={() => props.onChange(props.id, active ? "remove" : "add")} />
        </div>
    )
}

//  Requirements taht are a single boolean switch. This is the toggle.
function BooleanToggle(props) {
    const active = props.active == "true" ? true : props.active == "false" ? false : props.active;

    return (
        <div className="padding-left-4">
            <ToggleSwitch active={active} toggleActive={() => props.onChange(active ? "false" : "true")} />
        </div>
    )
}

function ToggleSwitch(props) {
    return (
        <div className="individual-toggle-and-descriptor-container">
            <div className="form-check form-switch">
                <input className="researcher-toggle form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" style={{ transform: "scale(1.2)" }} checked={props.active} onChange={() => props.toggleActive()} />
            </div>
            <div className="individual-toggle-descriptor">
                {props.active ? "Included" : "Excluded"}
            </div>
        </div>

    )
}



function AgeRangeRequirement(props) {
    // Okay, we're receiving in a hash of either:
    // {"min": 18, "max": 25 }
    // or { }
    // or just one of the two.
    // If it's empty, 
    const defaultComparison = props.ageHash ? props.ageHash.min && props.ageHash.max ? "between" : props.ageHash.min ? "greater_than" : props.ageHash.max ? "less_than" : -1 : -1;
    const [comparison, setComparison] = useState(defaultComparison);
    const [age1, setAge1] = useState(props.ageHash ? props.ageHash.min ? props.ageHash.min : props.ageHash.max ? props.ageHash.max : "" : "");
    const [age2, setAge2] = useState(props.ageHash && props.ageHash.min && props.ageHash.max ? props.ageHash.max : "");

    const label1 = comparison == "greater_than" ? "Age" : comparison == "less_than" ? "Age" : "At least";
    const label2 = "At most"

    function saveAgeRange({ newComparison = comparison, newAge1 = age1, newAge2 = age2 }) {
        let newAgeHash = {}
        if (newComparison == -1) {
            newAgeHash = {};
        }
        if (newComparison == "greater_than") {
            if (newAge1) {
                props.onChange({ "min": newAge1 });
            }
        }
        if (newComparison == "less_than") {
            if (newAge1) {
                props.onChange({ "max": newAge1 });
            }
        }
        if (newComparison == "between") {
            if (newAge1 && newAge2) {
                props.onChange({ "min": newAge1, "max": newAge2 });
            } else if (newAge1) {
                props.onChange({ "min": newAge1 });
            } else if (newAge2) {
                props.onChange({ "max": newAge1 });
            }

        }
    }

    function updateComparison(value) {
        setComparison(value);
        saveAgeRange({ newComparison: value });
    }

    function updateAge1(value) {
        const intValue = parseInt(value)
        setAge1(intValue);
        saveAgeRange({ newAge1: intValue });
    }

    function updateAge2(value) {
        const intValue = parseInt(value)
        setAge2(intValue);
        saveAgeRange({ newAge2: intValue });
    }


    return (
        <div className="age-range-requirement-container">
            <NewDropdownQuestion value={comparison} onChange={(event) => updateComparison(event.target.value)}>
                <NewDropdownOption value={-1} isDisabled={true}>Select comparison</NewDropdownOption>
                <NewDropdownOption value="greater_than">At least</NewDropdownOption>
                <NewDropdownOption value="less_than">At most</NewDropdownOption>
                <NewDropdownOption value="between">Between</NewDropdownOption>
            </NewDropdownQuestion>
            {comparison != -1 && <NewIntegerField key="age-1" placeholder={"Age   "} value={age1} onChange={(event) => updateAge1(event.target.value)} min={18} max={100} step={1} inputStyle={{ maxHeight: "38px" }} />}
            {comparison == "between" && <><div className="sidebar-small-gray-text">and</div> <NewIntegerField key="age-2" placeholder={"Age   "} value={age2} onChange={(event) => updateAge2(event.target.value)} min={18} max={100} step={1} inputStyle={{ maxHeight: "38px" }} /></>}
        </div>
    )
}

function CountryRequirement(props) {
    const customStyles = {
        control: (styles) => ({
            ...styles,
            backgroundColor: '#0c0c0c',
            color: '#FEFEFE',
            borderColor: '#2C2C2C',
            width: '100%',
            flexGrow: 1,
            ':hover': {
                borderColor: '#2C2C2C'
            }
        }),
        menu: (styles) => ({
            ...styles,
            backgroundColor: '#0c0c0c',
            color: '#FEFEFE',
            borderColor: '#2C2C2C'
        }),
        option: (styles, { isFocused, isSelected }) => ({
            ...styles,
            backgroundColor: isFocused ? 'rgba(192, 192, 192, 0.3)' : isSelected ? '#FEFEFE' : '#0c0c0c',
            color: isFocused ? '#FEFEFE' : isSelected ? '#0c0c0c' : '#FEFEFE',
        }),
        multiValue: (styles) => ({
            ...styles,
            backgroundColor: '#2C2C2C',
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            color: '#FEFEFE',
        }),
        indicatorSeparator: (styles) => ({
            ...styles,
            backgroundColor: '#2C2C2C'
        }),
        dropdownIndicator: (styles) => ({
            ...styles,
            color: '#7c7c7c',
            ':hover': {
                color: '#7c7c7c'
            }
        }),
        groupHeading: (styles) => ({
            ...styles,
            color: '#FEFEFE',
            backgroundColor: '#2C2C2C',
        }),
        input: (styles) => ({
            ...styles,
            color: '#FEFEFE',
            flexGrow: 1,

        }),
    };

    // Create the options for the select
    // It may be grouped, or not. This handles both cases
    // Assumes that if it doesn't have an [:options] key, it has a [:groups] key
    const selectOptions = props.availableCountries.map((option) => {
        return { label: option["label"], value: option["id"] }
    })

    const activeOptions = (props.selectedCountryList && props.selectedCountryList.exclude && props.selectedCountryList.exclude.length) > 0 ?
        props.selectedCountryList.exclude.map((country_id) => {
            const country = props.availableCountries.find((country) => country.id == country_id);
            return { label: country["label"], value: country["id"] }
        })
        :
        [];


    function updateSelected(selected) {
        // console.log("New Selected", selected);
        const array = selected.map((option) => option.value);
        // console.log("Array: ", array);
        props.onChange({ exclude: array });
    }

    return (
        <div className="country-selects-container">
            <div className="country-select-all-container" key={"select-all-" + props.selectedCategoryType}>
                <div className="dropdown-label-copy mb-2">Exclude:</div>
                <Select isMulti isClearable
                    options={selectOptions}
                    placeholder="Excluded countries"
                    defaultValue={activeOptions}
                    onChange={(selected) => updateSelected(selected)}
                    styles={customStyles}
                />
            </div>
        </div>
    )
}

function getDefaultRequirement(type, options) {
    if (type == "toggles") {
        // Map each option to the option.id in an array.
        const selected = options.map((option) => option.id);
        return { selected: selected };
    }
    if (type == "boolean") {
        return "true";
    }
    if (type == "country-select") {
        return [];
    }
    if (type == "age-range") {
        return {};
    }
    return null;
}

export { AddRequirementsSideBar, SideBarContent, WalletSideBarContent };